import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ColourGradingForm from '../../../components/forms/ColourGradingForm';
import { useColourGradingApi } from '../../../hooks/useColourGradingApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ColourGradingDTO } from '../../../services/apiClient';

const ColourGradingEdit: React.FC = () => {
  const { getById, edit, isLoading } = useColourGradingApi();
  const [entityData, setEntityData] = useState<ColourGradingDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Colour Gradings', href: '/admin/colourgradings' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching ColourGrading data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/colourgradings');
    } catch (error) {
      console.error('Error updating ColourGrading:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/colourgradings"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ColourGrading.Edit"
    >
      {entityData ? (
        <ColourGradingForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/colourgradings')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ColourGradingEdit;
